import { fetchQuery_DEPRECATED as fetchQuery, graphql, type Environment } from 'react-relay/legacy';

import {
    type fetchUserMetadataQuery$data,
    type fetchUserMetadataQuery,
} from './__generated__/fetchUserMetadataQuery.graphql';

const query = graphql`
    query fetchUserMetadataQuery($email: String = "") {
        viewer {
            userExistsMetadata(email: $email) {
                userExists
                emailOnly
            }
        }
    }
`;

type Viewer = NonNullable<fetchUserMetadataQuery$data['viewer']>;
export type Response = Viewer['userExistsMetadata'];
/**
 * we use the fetchQuery method here
 *    1) because we aren't in a react component context
 *    2) so we can fetch information dynamically for a potentially changing email address
 *    3) doing it in a refetch container would add a lot more code to the ContactDealer.jsx and ContactDealerInlineForm.jsx files (and would mean we couldn't share this code)
 * @param {*} emailField email to check auth metadata for
 * @param {*} environment relay environment
 */
export const fetchUserMetadata = async (
    emailField: string,
    environment: Environment
): Promise<Response> => {
    const data = await fetchQuery<fetchUserMetadataQuery>(environment, query, {
        email: emailField,
    });
    return data?.viewer?.userExistsMetadata;
};
